<template>
	<div class="">
		<transition name="slide-fade" appear>
			<flash-message :message="$store.getters.flashStatus" v-if="Object.keys($store.getters.flashStatus).length"></flash-message>
		</transition>
		<nav-bar @reload="compKey++" :key="compKey">
			<template v-if="$store.getters.jobName">
				{{ $store.getters.jobName }}
				<div class="block text-sm text-gray-400 sm:text-xl sm:inline-block sm:ml-2">{{ $route.name }}</div>
			</template>
			<template v-else>
				{{ $route.name }}
			</template>
		</nav-bar>
		<div class="container mx-auto flex-1 flex flex-col">
			<slot></slot>
		</div>
	</div>
</template>

<script>
import NavBar from '@/layouts/partials/NavBar.vue'
import FlashMessage from '@/components/common/FlashMessage.vue'
export default {
	props: ['route'],
	name: 'Default',

	data () {
		return {
			compKey: 1,
		}
	},
	components: {
		NavBar,
		FlashMessage
	}
}
</script>

<style lang="css" scoped>
/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-fade-enter-active, .slide-fade-leave-active{
  transition: all .4s ease;
}

.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateY(50px);
  opacity: 0;
}
</style>
